import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEstadoTropa = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'estado_tropa',
        name: 'Estado Tropa',
        component: ViewEstadoTropa,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
